import { SECOND } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { FENCES_LAYER_STYLE, FENCES_NAME_LAYER_STYLE, FENCES_OUTLINE_LAYER_STYLE } from '../../../constants/map';
import { useCamera } from '../../../hooks/useCamera';
import {
  fencesGeojsonState,
  selectedFenceGeojsonState,
  selectedFenceIdState,
  showFencesLayerState,
} from '../../../storage/map';
import { geometryIsPolygon } from '../../../utils/map';

export function FencesLayer() {
  const showFencesLayer = useRecoilValue(showFencesLayerState);
  const fencesGeojson = useRecoilValue(fencesGeojsonState);
  const selectedFenceGeojson = useRecoilValue(selectedFenceGeojsonState);
  const resetSelectedFenceId = useResetRecoilState(selectedFenceIdState);
  const { fitToLngLats } = useCamera();

  useEffect(() => {
    if (selectedFenceGeojson) {
      const geometry = selectedFenceGeojson.features[0]?.geometry;
      if (geometryIsPolygon(geometry)) {
        fitToLngLats(geometry.coordinates[0]);
      }
      const timeout = setTimeout(() => {
        resetSelectedFenceId();
      }, 5 * SECOND);
      return () => clearTimeout(timeout);
    }
  }, [selectedFenceGeojson]);

  if (!fencesGeojson) {
    return null;
  }

  return (
    <>
      {showFencesLayer && (
        <Source
          type="geojson"
          data={fencesGeojson}
          id="fences"
        >
          <Layer {...FENCES_LAYER_STYLE} />
          <Layer {...FENCES_OUTLINE_LAYER_STYLE} />
          <Layer {...FENCES_NAME_LAYER_STYLE} />
        </Source>
      )}
      {selectedFenceGeojson && !showFencesLayer && (
        <Source
          type="geojson"
          data={selectedFenceGeojson}
          id="selected-fence"
        >
          <Layer {...FENCES_LAYER_STYLE} />
          <Layer {...FENCES_OUTLINE_LAYER_STYLE} />
          <Layer {...FENCES_NAME_LAYER_STYLE} />
        </Source>
      )}
    </>
  );
}
